module.exports = __webpack_public_path__ + "img/infrastructure-6.57723d5a.png";